export const SW_VERSION = '1.1.4';
